import angular from 'angular'

import businessProfileComponent from './businessProfile.component'

export default angular.module('app.pages.admin.loanRequestDetails.businessProfile', [])
  .directive('adminLoanRequestBusinessProfile', businessProfileComponent)
